<template lang="html">
  <header class="flex justify-between items-center px-10 h-30">
    <slideMenu />
    <router-link to="/">
      <h1 class="text-5xl text-purple-900 inline-block align-middle py-9">
        Karin's Page
      </h1>
    </router-link>
  </header>
</template>

<script>
  import slideMenu from '@/components/slideMenu.vue'

  export default {
    components: {
      slideMenu
    }
  }
</script>

<style lang="scss" scoped>
  h1 {
     color: #432444; 
    font-family: 'Sacramento', cursive;
    /* font-size: 30px; */
    height: 100px
  }
</style>